import React from 'react';

import Banner from './Banner';
import Collaboration from './Collaboration';
import OlineReference from './OlineReference';

const ContactUs = () => {
  return (
    <div className="space-y-20 lg:space-y-[120px] xl:space-y-[140px]">
      <Banner />
      <div className="mx-5 lg:mx-auto lg:w-[848px] xl:w-[1164px]">
        <OlineReference />
        <div className="mt-20 lg:mt-12 xl:mt-[80px]">
          <Collaboration />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
